class MonadicError extends Error{constructor(m,p,e,a,c){super(m);this.name='MonadicError';this.path=p;this.expected=e;this.actual=a;this.callStack=c}};
function typeError(p,e,v){const a=v===null?'null':typeof v;const err=new MonadicError('Expected '+e+" for '"+p+"', got "+a,p,e,a);const c=globalThis.__tjs?.getConfig?.();if(c?.logTypeErrors)console.error('[TJS TypeError] '+err.message);if(c?.throwTypeErrors)throw err;return err};
function isMonadicError(v){return v instanceof Error&&v.name==='MonadicError'&&'path' in v};
const __stack=[];function pushStack(n){__stack.push(n)}function popStack(){__stack.pop()}function getStack(){return[...__stack]};
function Type(d,p,e){const t={description:d,__runtimeType:true};if(typeof p==='function'){t.check=p;t.default=e??null}else{const ex=e??p;t.default=ex;t.check=v=>{if(ex===null)return true;return typeof v===typeof ex}}return t};
function Generic(tp,pred,d){const f=(...args)=>{const t={description:d||'generic',__runtimeType:true,check:v=>pred(v,...args)};return t};f.__runtimeType=true;f.description=d;return f};
const __tjs = globalThis.__tjs?.createRuntime?.() ?? {typeError,isMonadicError,pushStack,popStack,getStack,Type,Generic};
/* tjs <- metadata.ts */

/*#
# metadata

## `tosiAccessor(x: any): TosiAccessor | undefined`

`tosiAccessor` returns the collision-free accessor object from any boxed proxy,
using the `TOSI_ACCESSOR` symbol internally. Returns `undefined` for non-proxy values.

This is the guaranteed escape hatch — it works even if your data has a property
named `tosi` that would shadow the `.tosi` convenience accessor.

```
import { tosiAccessor, TOSI_ACCESSOR } from 'tosijs'

const { app } = tosi({ app: { tosi: 'shadowed!', name: 'test' } })

// .tosi is always intercepted by the proxy (not shadowed in practice)
app.tosi.path === 'app'

// tosiAccessor() and TOSI_ACCESSOR are guaranteed collision-free
const acc = tosiAccessor(app)
acc.path === 'app'
acc.value  // { tosi: 'shadowed!', name: 'test' }

// TOSI_ACCESSOR symbol works directly
app[TOSI_ACCESSOR].path === 'app'

// returns undefined for non-proxy values
tosiAccessor('hello') === undefined
tosiAccessor({ foo: 1 }) === undefined
```

## `xinValue(x: any): any` (deprecated)

`xinValue` strips the `xin` or `boxed` proxy off of a value.
Passes through non-proxy values unchanged. Prefer `.value` or `.tosi.value`.

```
import { boxed } from 'tosijs'

const foo = { bar: 'hello', baz: 17 }
boxed.foo = foo

boxed.foo.bar === foo.bar               // false, boxed.foo.bar is a proxy
boxed.foo === foo                       // false, boxed.foo is a proxy
boxed.foo.baz === 17                    // false, boxed.foo.baz is a proxy
boxed.foo.bar.value === 'hello'         // true (preferred)
xinValue(boxed.foo.bar) === 'hello'     // true
boxed.foo.baz.value === 17              // true
xinValue(boxed.foo) === xinValue(foo)   // true
foo.xinValue                            // undefined! foo isn't a proxy
```

## `xinPath(x: any): string | undefined` (deprecated)

`xinPath` returns the path of a `xin` or `boxed` proxy. Returns `undefined`
for non-proxy values. Prefer `.path` or `.tosi.path`.
*/

import { XinObject, XinProps, XinBinding, XinEventHandler, Unboxed } from './xin-types'

import { deepClone } from './deep-clone'

export const BOUND_CLASS = '-xin-data';

export const BOUND_SELECTOR = `.${BOUND_CLASS}`;

export const EVENT_CLASS = '-xin-event';

export const EVENT_SELECTOR = `.${EVENT_CLASS}`;

export const XIN_PATH = Symbol.for('xin-path');

export const XIN_VALUE = Symbol.for('xin-value');

export const XIN_OBSERVE = 'xinObserve';

export const XIN_BIND = 'xinBind';

export const XIN_ON = 'xinOn';

export const TOSI_ACCESSOR = Symbol.for('tosi-accessor');

export const TAKE_DESCRIPTOR = Symbol.for('tosi-take');

export const LIST_BINDING_REF = Symbol('list-binding');

export const LIST_INSTANCE_REF = Symbol('list-instance');

const arrayIdPathRegistry = new Map();

/* line 96 */
export function registerArrayIdPath(arrayPath,idPath) {
  try {
  __tjs.pushStack('metadata.ts:95:registerArrayIdPath');
  if (arrayPath instanceof Error) return arrayPath;
  if (idPath instanceof Error) return idPath;
  if (typeof arrayPath !== 'string') return __tjs.typeError('metadata.ts:95:registerArrayIdPath.arrayPath', 'string', arrayPath);
  if (typeof idPath !== 'string') return __tjs.typeError('metadata.ts:95:registerArrayIdPath.idPath', 'string', idPath);

    let idPaths = arrayIdPathRegistry.get(arrayPath);
    if (idPaths === undefined) {
        idPaths = new Set();
        arrayIdPathRegistry.set(arrayPath, idPaths);
    }
    idPaths.add(idPath);

  } finally { __tjs.popStack(); }
}
registerArrayIdPath.__tjs = {
  "params": {
    "arrayPath": {
      "type": {
        "kind": "string"
      },
      "required": true,
      "default": null
    },
    "idPath": {
      "type": {
        "kind": "string"
      },
      "required": true,
      "default": null
    }
  },
  "source": "metadata.ts:95"
}

/* line 108 */
export function getArrayIdPaths(arrayPath) {
  try {
  __tjs.pushStack('metadata.ts:105:getArrayIdPaths');
  if (arrayPath instanceof Error) return arrayPath;
  if (typeof arrayPath !== 'string') return __tjs.typeError('metadata.ts:105:getArrayIdPaths.arrayPath', 'string', arrayPath);

    return arrayIdPathRegistry.get(arrayPath);

  } finally { __tjs.popStack(); }
}
getArrayIdPaths.__tjs = {
  "params": {
    "arrayPath": {
      "type": {
        "kind": "string"
      },
      "required": true,
      "default": null
    }
  },
  "source": "metadata.ts:105"
}

/* line 115 */
export function unregisterArrayIdPath(arrayPath,idPath) {
  try {
  __tjs.pushStack('metadata.ts:110:unregisterArrayIdPath');
  if (arrayPath instanceof Error) return arrayPath;
  if (idPath instanceof Error) return idPath;
  if (typeof arrayPath !== 'string') return __tjs.typeError('metadata.ts:110:unregisterArrayIdPath.arrayPath', 'string', arrayPath);
  if (typeof idPath !== 'string') return __tjs.typeError('metadata.ts:110:unregisterArrayIdPath.idPath', 'string', idPath);

    const idPaths = arrayIdPathRegistry.get(arrayPath);
    if (idPaths !== undefined) {
        idPaths.delete(idPath);
        if (idPaths.size === 0) {
            arrayIdPathRegistry.delete(arrayPath);
        }
    }

  } finally { __tjs.popStack(); }
}
unregisterArrayIdPath.__tjs = {
  "params": {
    "arrayPath": {
      "type": {
        "kind": "string"
      },
      "required": true,
      "default": null
    },
    "idPath": {
      "type": {
        "kind": "string"
      },
      "required": true,
      "default": null
    }
  },
  "source": "metadata.ts:110"
}

/* line 128 */
export function _getArrayIdPathRegistry() {
    return arrayIdPathRegistry;
}
_getArrayIdPathRegistry.__tjs = {
  "params": {},
  "source": "metadata.ts:121"
}

const deprecationWarnings = new Set();

/* line 138 */
export function warnDeprecated(key,message) {
  try {
  __tjs.pushStack('metadata.ts:128:warnDeprecated');
  if (key instanceof Error) return key;
  if (message instanceof Error) return message;
  if (typeof key !== 'string') return __tjs.typeError('metadata.ts:128:warnDeprecated.key', 'string', key);
  if (typeof message !== 'string') return __tjs.typeError('metadata.ts:128:warnDeprecated.message', 'string', message);

    if (!deprecationWarnings.has(key)) {
        console.warn(message);
        deprecationWarnings.add(key);
    }

  } finally { __tjs.popStack(); }
}
warnDeprecated.__tjs = {
  "params": {
    "key": {
      "type": {
        "kind": "string"
      },
      "required": true,
      "default": null
    },
    "message": {
      "type": {
        "kind": "string"
      },
      "required": true,
      "default": null
    }
  },
  "source": "metadata.ts:128"
}

/* line 148 */
export function _resetDeprecationWarnings() {
    deprecationWarnings.clear();
}
_resetDeprecationWarnings.__tjs = {
  "params": {},
  "source": "metadata.ts:136"
}

/* line 155 */
export function deprecated(fn,message = '') {
  try {
  __tjs.pushStack('metadata.ts:141:deprecated');
  if (fn instanceof Error) return fn;
  if (message instanceof Error) return message;
  if (message !== undefined && typeof message !== 'string') return __tjs.typeError('metadata.ts:141:deprecated.message', 'string', message);

    let warned = false;
    return ((...args) => {
        if (!warned) {
            console.warn(message);
            warned = true;
        }
        return fn(...args);
    });

  } finally { __tjs.popStack(); }
}
deprecated.__tjs = {
  "params": {
    "fn": {
      "type": {
        "kind": "any"
      },
      "required": true,
      "default": null
    },
    "message": {
      "type": {
        "kind": "string"
      },
      "required": false,
      "default": ""
    }
  },
  "source": "metadata.ts:141"
}

/* line 173 */
export function tosiPath(x) {
  try {
  __tjs.pushStack('metadata.ts:153:tosiPath');
  if (x instanceof Error) return x;

    return (x && x[XIN_PATH]) || undefined;

  } finally { __tjs.popStack(); }
}
tosiPath.__tjs = {
  "params": {
    "x": {
      "type": {
        "kind": "any"
      },
      "required": false
    }
  },
  "returns": {
    "type": {
      "kind": "union",
      "members": [
        {
          "kind": "string"
        },
        {
          "kind": "undefined"
        }
      ]
    }
  },
  "unsafeReturn": true,
  "source": "metadata.ts:153"
}

/* line 181 */
/* TODO: TS types degraded — x: T, return: Unboxed<T> */
export function tosiValue(x) {
  try {
  __tjs.pushStack('metadata.ts:159:tosiValue');
  if (x instanceof Error) return x;

    if (typeof x === 'object' && x !== null) {
        const val = x[XIN_VALUE];
        return (val !== undefined ? val : x);
    }
    return x;

  } finally { __tjs.popStack(); }
}
tosiValue.__tjs = {
  "params": {
    "x": {
      "type": {
        "kind": "any"
      },
      "required": false
    }
  },
  "source": "metadata.ts:159"
}

/* line 194 */
/* TODO: TS types degraded — return: any | undefined */
export function tosiAccessor(x) {
  try {
  __tjs.pushStack('metadata.ts:169:tosiAccessor');
  if (x instanceof Error) return x;

    return x != null ? x[TOSI_ACCESSOR] : undefined;

  } finally { __tjs.popStack(); }
}
tosiAccessor.__tjs = {
  "params": {
    "x": {
      "type": {
        "kind": "any"
      },
      "required": false
    }
  },
  "source": "metadata.ts:169"
}

/* line 202 */
/* TODO: TS types degraded — value: T */
export function tosiSetValue(proxy, value) {
  try {
  __tjs.pushStack('metadata.ts:175:tosiSetValue');
  if (proxy instanceof Error) return proxy;
  if (value instanceof Error) return value;

    const path = tosiPath(proxy);
    if (path === undefined) {
        throw new Error('tosiSetValue requires a xin or boxed proxy');
    }
    proxy[XIN_VALUE] = value;

  } finally { __tjs.popStack(); }
}
tosiSetValue.__tjs = {
  "params": {
    "proxy": {
      "type": {
        "kind": "any"
      },
      "required": false
    },
    "value": {
      "type": {
        "kind": "any"
      },
      "required": false
    }
  },
  "source": "metadata.ts:175"
}

export const xinPath = deprecated(tosiPath, 'xinPath is deprecated. Use tosiPath instead.');

export const xinValue = deprecated(tosiValue, 'xinValue is deprecated. Use tosiValue instead.');

export const DataBinding = Generic([['T', {}]], (x, checkT) => { return typeof x === 'object' && x !== null && 'path' in x && 'binding' in x && 'options' in x }, 'DataBinding')

export const DataBindings = Type('DataBindings', undefined, [null])

export const XinEventBindings = Type('XinEventBindings')

export const elementToHandlers = new WeakMap();

export const elementToBindings = new WeakMap();

const ElementMetadata = Type('ElementMetadata', undefined, { eventBindings: null, dataBindings: null })

/* line 243 */
export function getElementBindings(element) {
  try {
  __tjs.pushStack('metadata.ts:200:getElementBindings');
  if (element instanceof Error) return element;
  if ((typeof element !== 'object' || element === null || Array.isArray(element))) return __tjs.typeError('metadata.ts:200:getElementBindings.element', 'object', element);

    return {
        eventBindings: elementToHandlers.get(element),
        dataBindings: elementToBindings.get(element),
    };

  } finally { __tjs.popStack(); }
}
getElementBindings.__tjs = {
  "params": {
    "element": {
      "type": {
        "kind": "object",
        "shape": {}
      },
      "required": true,
      "default": null
    }
  },
  "returns": {
    "type": {
      "kind": "object",
      "shape": {
        "eventBindings": {
          "kind": "object",
          "shape": {}
        },
        "dataBindings": {
          "kind": "array",
          "items": {
            "kind": "null"
          }
        }
      }
    }
  },
  "unsafeReturn": true,
  "source": "metadata.ts:200"
}

/* line 250 */
export function cloneWithBindings(element) {
  try {
  __tjs.pushStack('metadata.ts:208:cloneWithBindings');
  if (element instanceof Error) return element;
  if ((typeof element !== 'object' || element === null || Array.isArray(element))) return __tjs.typeError('metadata.ts:208:cloneWithBindings.element', 'object', element);

    const cloned = element.cloneNode();
    if (cloned instanceof Element) {
        const dataBindings = elementToBindings.get(element);
        const eventHandlers = elementToHandlers.get(element);
        if (dataBindings != null) {
            // @ts-expect-error deepClone returns compatible type
            elementToBindings.set(cloned, deepClone(dataBindings));
        }
        if (eventHandlers != null) {
            // @ts-expect-error deepClone returns compatible type
            elementToHandlers.set(cloned, deepClone(eventHandlers));
        }
    }
    for (const node of Array.from(element instanceof HTMLTemplateElement
        ? element.content.childNodes
        : element.childNodes)) {
        if (node instanceof Element || node instanceof DocumentFragment) {
            cloned.appendChild(cloneWithBindings(node));
        }
        else {
            cloned.appendChild(node.cloneNode());
        }
    }
    return cloned;

  } finally { __tjs.popStack(); }
}
cloneWithBindings.__tjs = {
  "params": {
    "element": {
      "type": {
        "kind": "object",
        "shape": {}
      },
      "required": true,
      "default": null
    }
  },
  "returns": {
    "type": {
      "kind": "object",
      "shape": {}
    }
  },
  "unsafeReturn": true,
  "source": "metadata.ts:208"
}